import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION } from '../../../constants'
import { Service } from '../../../../types'

type ClInfo = {
  badge?: string
  header: string
  subHeader: string
  actionText: string
}

type ClCraftingProps = {
  status: 'initial' | 'completed'
  text: ClInfo
}

export const useClCraftingConfig = (service: Service): ClCraftingProps => {
  const { i18n } = useI18n()

  const getStatus = () => {
    if (service.progress === 100) return 'completed'
    return 'initial'
  }

  const getText = (): ClInfo => {
    const status = getStatus()
    const key = status === 'completed' ? 'completed' : `cover_letter_crafting.${status}`

    return i18n.t(`${TRANSLATION}.${key}`) as unknown as ClInfo
  }

  return {
    text: getText(),
    status: getStatus(),
  }
}
